(function(){
  try{if(window.self!==window.top)document.getElementById('iframeBanner').style.display='block';}
  catch(e){document.getElementById('iframeBanner').style.display='block';}
})();

(function(){
'use strict';
function _mapGenInit(){

const DEG2RAD=Math.PI/180;

const A2N={
  AD:20,AE:784,AF:4,AG:28,AL:8,AM:51,AO:24,AR:32,AT:40,AU:36,AZ:31,
  BA:70,BB:52,BD:50,BE:56,BF:854,BG:100,BH:48,BI:108,BJ:204,BN:96,
  BO:68,BR:76,BS:44,BT:64,BW:72,BY:112,BZ:84,CA:124,CD:180,CF:140,
  CG:178,CH:756,CI:384,CL:152,CM:120,CN:156,CO:170,CR:188,CU:192,
  CV:132,CY:196,CZ:203,DE:276,DJ:262,DK:208,DM:212,DO:214,DZ:12,
  EC:218,EE:233,EG:818,ER:232,ES:724,ET:231,FI:246,FJ:242,FM:583,
  FR:250,GA:266,GB:826,GD:308,GE:268,GH:288,GM:270,GN:324,GQ:226,
  GR:300,GT:320,GW:624,GY:328,HN:340,HR:191,HT:332,HU:348,ID:360,
  IE:372,IL:376,IN:356,IQ:368,IR:364,IS:352,IT:380,JM:388,JO:400,
  JP:392,KE:404,KG:417,KH:116,KI:296,KM:174,KN:659,KP:408,KR:410,
  KW:414,KZ:398,LA:418,LB:422,LC:662,LI:438,LK:144,LR:430,LS:426,
  LT:440,LU:442,LV:428,LY:434,MA:504,MC:492,MD:498,ME:499,MG:450,
  MH:584,MK:807,ML:466,MM:104,MN:496,MR:478,MT:470,MU:480,MV:462,
  MW:454,MX:484,MY:458,MZ:508,NA:516,NE:562,NG:566,NI:558,NL:528,
  NO:578,NP:524,NR:520,NZ:554,OM:512,PA:591,PE:604,PG:598,PH:608,
  PK:586,PL:616,PT:620,PW:585,PY:600,QA:634,RO:642,RS:688,RU:643,
  RW:646,SA:682,SB:90,SC:690,SD:729,SE:752,SG:702,SI:705,SK:703,
  SL:694,SM:674,SN:686,SO:706,SR:740,SS:728,ST:678,SV:222,SY:760,
  SZ:748,TD:148,TG:768,TH:764,TJ:762,TL:626,TM:795,TN:788,TO:776,
  TR:792,TT:780,TV:798,TZ:834,UA:804,UG:800,US:840,UY:858,UZ:860,
  VA:336,VC:670,VE:862,VN:704,VU:548,WS:882,YE:887,ZA:710,ZM:894,ZW:716
};

let worldAtlas=null;
async function getWorldAtlas(){
  if(worldAtlas) return worldAtlas;
  const r=await fetch('https://cdn.jsdelivr.net/npm/world-atlas@2/countries-10m.json',{signal:AbortSignal.timeout(20000)});
  if(!r.ok) throw new Error('Could not load world atlas');
  worldAtlas=await r.json();
  return worldAtlas;
}

function countryGeoFromAtlas(atlas,isoNumeric){
  const id=String(isoNumeric);
  const fc=topojson.feature(atlas,atlas.objects.countries);
  return fc.features.find(f=>String(f.id)===id)||null;
}

/* ── US state boundaries (Census Bureau via us-atlas) ──
   High-detail lon/lat data — preserves peninsulas, coves, and islands
   that Nominatim's search endpoint drops. */
const US_STATE_FIPS={
  'Alabama':'01','Alaska':'02','Arizona':'04','Arkansas':'05','California':'06',
  'Colorado':'08','Connecticut':'09','Delaware':'10','District of Columbia':'11',
  'Florida':'12','Georgia':'13','Hawaii':'15','Idaho':'16','Illinois':'17',
  'Indiana':'18','Iowa':'19','Kansas':'20','Kentucky':'21','Louisiana':'22',
  'Maine':'23','Maryland':'24','Massachusetts':'25','Michigan':'26','Minnesota':'27',
  'Mississippi':'28','Missouri':'29','Montana':'30','Nebraska':'31','Nevada':'32',
  'New Hampshire':'33','New Jersey':'34','New Mexico':'35','New York':'36',
  'North Carolina':'37','North Dakota':'38','Ohio':'39','Oklahoma':'40','Oregon':'41',
  'Pennsylvania':'42','Rhode Island':'44','South Carolina':'45','South Dakota':'46',
  'Tennessee':'47','Texas':'48','Utah':'49','Vermont':'50','Virginia':'51',
  'Washington':'53','West Virginia':'54','Wisconsin':'55','Wyoming':'56',
};

let usAtlas=null;
async function getUsAtlas(){
  if(usAtlas) return usAtlas;
  /* counties-10m contains an unprojected (lon/lat) 'states' collection */
  const r=await fetch('https://cdn.jsdelivr.net/npm/us-atlas@3/counties-10m.json',{signal:AbortSignal.timeout(25000)});
  if(!r.ok) throw new Error('Could not load US state atlas');
  usAtlas=await r.json();
  return usAtlas;
}

function usStateGeoFromAtlas(atlas,fips){
  const id=String(fips);
  const fc=topojson.feature(atlas,atlas.objects.states);
  return fc.features.find(f=>String(f.id)===id)||null;
}

function normaliseRing(ring){
  if(!ring||!ring.length) return ring;
  const out=[[ring[0][0],ring[0][1]]];
  for(let i=1;i<ring.length;i++){
    let lo=ring[i][0];
    const prev=out[i-1][0];
    while(lo-prev>180) lo-=360;
    while(prev-lo>180) lo+=360;
    out.push([lo,ring[i][1]]);
  }
  return out;
}

function extractRings(geo){
  const outers=[],inners=[];
  if(!geo) return{outers,inners};
  if(geo.type==='Feature') return extractRings(geo.geometry);
  if(geo.type==='FeatureCollection'){
    geo.features.forEach(f=>{const r=extractRings(f);outers.push(...r.outers);inners.push(...r.inners);});
    return{outers,inners};
  }
  function addPoly(coords){
    if(!coords||!coords[0]||coords[0].length<4) return;
    outers.push(normaliseRing(coords[0]));
    for(let i=1;i<coords.length;i++) if(coords[i].length>=4) inners.push(normaliseRing(coords[i]));
  }
  if(geo.type==='Polygon') addPoly(geo.coordinates);
  else if(geo.type==='MultiPolygon') geo.coordinates.forEach(p=>addPoly(p));
  else if(geo.type==='GeometryCollection') geo.geometries.forEach(g=>{const r=extractRings(g);outers.push(...r.outers);inners.push(...r.inners);});
  return{outers,inners};
}

function filterByProximity(outers,inners){
  if(!outers.length) return{outers:[],inners:[]};
  function stats(ring){
    let minLo=Infinity,maxLo=-Infinity,minLa=Infinity,maxLa=-Infinity;
    ring.forEach(([lo,la])=>{if(lo<minLo)minLo=lo;if(lo>maxLo)maxLo=lo;if(la<minLa)minLa=la;if(la>maxLa)maxLa=la;});
    return{cx:(minLo+maxLo)/2,cy:(minLa+maxLa)/2,area:(maxLo-minLo)*(maxLa-minLa),minLo,maxLo,minLa,maxLa};
  }
  const s=outers.map(stats);
  const mi=s.reduce((bi,x,i)=>x.area>s[bi].area?i:bi,0);
  const m=s[mi];
  const thresh=Math.max(35,Math.hypot(m.maxLo-m.minLo,m.maxLa-m.minLa)*0.6);
  const kept=outers.filter((_,i)=>Math.hypot(s[i].cx-m.cx,s[i].cy-m.cy)<=thresh);
  let kMinLo=Infinity,kMaxLo=-Infinity,kMinLa=Infinity,kMaxLa=-Infinity;
  kept.forEach(r=>r.forEach(([lo,la])=>{if(lo<kMinLo)kMinLo=lo;if(lo>kMaxLo)kMaxLo=lo;if(la<kMinLa)kMinLa=la;if(la>kMaxLa)kMaxLa=la;}));
  const ki=inners.filter(r=>{const is=stats(r);return is.cx>=kMinLo-1&&is.cx<=kMaxLo+1&&is.cy>=kMinLa-1&&is.cy<=kMaxLa+1;});
  return{outers:kept,inners:ki};
}

function rdp(pts,eps){
  if(pts.length<3) return pts;
  let maxD=0,idx=0;
  const last=pts.length-1;
  const[ax,ay]=pts[0],[bx,by]=pts[last];
  const dx=bx-ax,dy=by-ay,len2=dx*dx+dy*dy;
  for(let i=1;i<last;i++){
    const[px,py]=pts[i];
    let d;
    if(len2===0) d=Math.hypot(px-ax,py-ay);
    else{const t=Math.max(0,Math.min(1,((px-ax)*dx+(py-ay)*dy)/len2));d=Math.hypot(px-(ax+t*dx),py-(ay+t*dy));}
    if(d>maxD){maxD=d;idx=i;}
  }
  if(maxD>eps) return[...rdp(pts.slice(0,idx+1),eps).slice(0,-1),...rdp(pts.slice(idx),eps)];
  return[pts[0],pts[last]];
}

function chaikin(pts,iter){
  /* Edge-length-aware Chaikin: only rounds corners where both adjacent edges
     are SHORT (local coastal bumps). Corners adjacent to long edges (major
     surveyed borders like Manitoba's meridians) are left unrounded. */
  if(iter<=0||pts.length<4) return pts;
  let p=pts;
  for(let k=0;k<iter;k++){
    const n=p.length;
    /* compute shape extent so edge length threshold scales with shape size */
    let mnX=Infinity,mxX=-Infinity,mnY=Infinity,mxY=-Infinity;
    p.forEach(([x,y])=>{if(x<mnX)mnX=x;if(x>mxX)mxX=x;if(y<mnY)mnY=y;if(y>mxY)mxY=y;});
    const longEdge=Math.hypot(mxX-mnX,mxY-mnY)*0.07; /* >7% of shape diagonal = major feature */
    const sharp=p.map((_,i)=>{
      const prev=p[(i-1+n)%n],cur=p[i],next=p[(i+1)%n];
      const ax=cur[0]-prev[0],ay=cur[1]-prev[1];
      const bx=next[0]-cur[0],by=next[1]-cur[1];
      const la=Math.hypot(ax,ay),lb=Math.hypot(bx,by);
      if(la<.001||lb<.001) return false;
      /* skip if either adjacent edge is a long border segment */
      if(la>longEdge||lb>longEdge) return false;
      const cos=(ax*bx+ay*by)/(la*lb);
      return Math.acos(Math.max(-1,Math.min(1,cos)))*180/Math.PI>20;
    });
    const out=[];
    for(let i=0;i<n;i++){
      const a=p[i],b=p[(i+1)%n];
      out.push([0.75*a[0]+0.25*b[0],0.75*a[1]+0.25*b[1]]);
      if(sharp[(i+1)%n]) out.push([0.25*a[0]+0.75*b[0],0.25*a[1]+0.75*b[1]]);
      else out.push(b);
    }
    p=out;
  }
  return p;
}

async function getJson(url,ms=10000){
  const srcs=[
    ()=>fetch(url,{signal:AbortSignal.timeout(ms)}),
    ()=>fetch(`https://corsproxy.io/?url=${encodeURIComponent(url)}`,{signal:AbortSignal.timeout(ms)}),
    ()=>fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,{signal:AbortSignal.timeout(ms)}),
  ];
  for(const s of srcs){
    try{
      const r=await s();if(!r.ok) continue;
      const t=await r.text();
      const j=JSON.parse(t);
      return(j&&typeof j==='object'&&'contents' in j)?JSON.parse(j.contents):j;
    }catch(_){}
  }
  throw new Error('NETWORK_BLOCKED');
}

/* ── State ── */
let currentUnit='in',shapeRatio=1,hasShape=false;
let heartMode='layered'; /* 'layered' | 'cutout' */
let _placeTimer=null,lastFetched='',cachedData=null;
const geoCache={};
let _proj=null;
let hoopEnabled=false;
let islandFilter=false;
let smoothEdges=false;
let _projRings={outers:[],inners:[]};  /* simplified projected rings, saved in renderShape */
let _hoopCx=null,_hoopCy=null;        /* hoop centre in SVG viewBox coords */
let _dragging=false,_dox=0,_doy=0;    /* drag state */

const placeName   =document.getElementById('placeName');
const clearBtn    =document.getElementById('clearBtn');
const inSpin      =document.getElementById('inSpin');
const statusMsg   =document.getElementById('statusMsg');
const DETAIL_LEVEL=85; /* fixed detail, slider removed */
const previewSvg  =document.getElementById('previewSvg');
const shapePath   =document.getElementById('shapePath');
const placeLabel  =document.getElementById('placeLabel');
const emptyOverlay=document.getElementById('emptyOverlay');
const loadOverlay =document.getElementById('loadOverlay');
const loadMsg     =document.getElementById('loadMsg');
const btnDl       =document.getElementById('btnDl');
const sizenote    =document.getElementById('sizenote');

placeName.addEventListener('input',()=>{
  clearBtn.style.display=placeName.value?'block':'none';
  clearTimeout(_placeTimer);
  const q=placeName.value.trim();
  clearHeart();
  addrStatus.textContent='';addrStatus.className='status-line';
  if(!q){showEmpty();return;}
  _placeTimer=setTimeout(()=>fetchShape(q),700);
});
placeName.addEventListener('keydown',e=>{
  if(e.key==='Enter'){clearTimeout(_placeTimer);const q=placeName.value.trim();if(q)fetchShape(q);}
});
clearBtn.addEventListener('click',()=>{placeName.value='';clearBtn.style.display='none';showEmpty();});

async function fetchShape(query){
  const key=query.toLowerCase().trim();
  if(geoCache[key]){cachedData=geoCache[key];renderShape(cachedData);return;}
  if(key===lastFetched) return;
  lastFetched=key;
  showLoading('Searching…');setStatus('');
  clearHeart();
  addrStatus.textContent='';addrStatus.className='status-line';
  try{
    const nomUrl=`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1&addressdetails=1&polygon_geojson=0`;
    const nomData=await getJson(nomUrl,8000);
    if(!nomData||!nomData.length){showEmpty();setStatus(`No results for "${query}"`,true);return;}
    const place=nomData[0];
    const label=place.display_name.split(',')[0].trim();
    const displayName=place.display_name.split(',').slice(0,3).join(', ');
    const cc=(place.address&&place.address.country_code)?place.address.country_code.toUpperCase():null;
    const isCountry=place.osm_type==='relation'&&(
      place.type==='country'||(place.address&&(
        place.display_name.split(',')[0].trim()===place.address.country||
        place.address.country_code&&!place.address.state&&!place.address.city
      ))
    );
    let geo=null;
    if(isCountry&&cc&&A2N[cc]){
      showLoading('Loading country data…');
      const atlas=await getWorldAtlas();
      const feature=countryGeoFromAtlas(atlas,A2N[cc]);
      if(feature) geo=feature.geometry;
    }

    /* Territories / dependencies that aren't detected as sovereign countries
       but DO have their own polygons in the world-atlas dataset.
       Keyed by the first segment of the Nominatim display_name. */
    const TERRITORY_NUM={
      'Puerto Rico':630,'Greenland':304,'Hong Kong':344,'Macau':446,
      'Western Sahara':732,'Kosovo':383,'Taiwan':158,'Guam':316,
      'Northern Mariana Islands':580,'American Samoa':16,'Aruba':533,
      'Curaçao':531,'New Caledonia':540,'French Polynesia':258,
      'Falkland Islands':238,'Gibraltar':292,'Bermuda':60,
    };
    if(!geo&&TERRITORY_NUM[label]){
      showLoading('Loading territory data…');
      const atlas=await getWorldAtlas();
      const feature=countryGeoFromAtlas(atlas,TERRITORY_NUM[label]);
      if(feature) geo=feature.geometry;
    }

    /* US states — use us-atlas Census Bureau data (10m detail).
       Nominatim's polygon endpoints drop narrow peninsulas (e.g. WI's Door). */
    if(!geo&&cc==='US'&&US_STATE_FIPS[label]){
      showLoading('Loading state data…');
      try{
        const atlas=await getUsAtlas();
        const feature=usStateGeoFromAtlas(atlas,US_STATE_FIPS[label]);
        if(feature) geo=feature.geometry;
      }catch(e){ console.warn('US atlas load failed:',e); }
    }

    if(!geo){
      showLoading('Loading boundary…');
      const polyUrl=`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1&polygon_geojson=1&polygon_threshold=0`;
      const pd=await getJson(polyUrl,12000);
      if(pd&&pd.length&&pd[0].geojson) geo=pd[0].geojson;
    }
    if(!geo||geo.type==='Point'){showEmpty();setStatus('No boundary found — try a country, state, or city',true);return;}
    const{outers,inners}=extractRings(geo);
    if(!outers.length){showEmpty();setStatus('No boundary found',true);return;}
    let filtered=isCountry?filterByProximity(outers,inners):{outers,inners};
    if(!filtered.outers.length){showEmpty();setStatus('No boundary found',true);return;}
    const entry={outers:filtered.outers,inners:filtered.inners,label,displayName};
    geoCache[key]=entry;cachedData=entry;
    renderShape(entry);setStatus(displayName,false);
  }catch(err){
    showEmpty();
    setStatus(err.message==='NETWORK_BLOCKED'
      ?'⚠ Network blocked — open this file directly in your browser'
      :'Error: '+err.message,true);
  }
}

function renderShape(entry){
  const{outers,inners,label}=entry;
  const SIZE=500,PAD=30;
  const v=DETAIL_LEVEL;
  const eps=Math.pow(10,1.3-(v/100)*2.1);
  const smoothIter=Math.round(Math.max(0,(1-(v-25)/50)*3));

  const D2R=Math.PI/180;
  let minX=Infinity,maxX=-Infinity,minY=Infinity,maxY=-Infinity;
  outers.forEach(ring=>ring.forEach(([lo,la])=>{
    if(lo<minX)minX=lo;if(lo>maxX)maxX=lo;
    if(la<minY)minY=la;if(la>maxY)maxY=la;
  }));

  const latRange=maxY-minY;
  const lonRange=maxX-minX;
  const midLon=(minX+maxX)/2;
  const midLat=(minY+maxY)/2;
  const phi1r=(minY+latRange/6)*D2R;
  const phi2r=(minY+5*latRange/6)*D2R;
  const phi0r=midLat*D2R;
  const lam0r=midLon*D2R;

  /* Use LCC only for large shapes (countries spanning 20°+ latitude).
     Smaller shapes like provinces/states have straight lat/lon borders
     (e.g. Manitoba's 60°N boundary) that look correct only in a
     cylindrical projection — LCC curves those boundaries into arcs,
     making the top appear pinched. Equirectangular keeps parallels flat. */
  const lccOk=(phi1r*phi2r>0||Math.abs(phi1r)<0.01||Math.abs(phi2r)<0.01)
              &&latRange>=20&&Math.abs(phi1r-phi2r)>1e-4;

  let projFn;
  if(lccOk){
    const n=Math.log(Math.cos(phi1r)/Math.cos(phi2r))/
            Math.log(Math.tan(Math.PI/4+phi2r/2)/Math.tan(Math.PI/4+phi1r/2));
    if(Math.abs(n)>0.05){
      const F=Math.cos(phi1r)*Math.pow(Math.tan(Math.PI/4+phi1r/2),n)/n;
      const rho0=F/Math.pow(Math.tan(Math.PI/4+phi0r/2),n);
      projFn=([lo,la])=>{
        const ph=la*D2R,lm=lo*D2R;
        const t=Math.tan(Math.PI/4+ph/2);
        if(t<=0) return[0,0];
        const rho=F/Math.pow(t,n);
        const th=n*(lm-lam0r);
        return[rho*Math.sin(th), rho*Math.cos(th)-rho0];
      };
    }
  }
  if(!projFn){
    /* Equirectangular with cosLat aspect correction.
       cosLat clamped to [0.20, 0.98] — lower bound avoids collapsing
       near-polar shapes to slivers; upper bound handles near-equatorial. */
    const cl=Math.min(0.98,Math.max(0.20,Math.cos(midLat*D2R)));
    projFn=([lo,la])=>[(lo-midLon)*cl, midLat-la];
  }
  const lccFn=projFn;

  let pMinX=Infinity,pMaxX=-Infinity,pMinY=Infinity,pMaxY=-Infinity;
  outers.forEach(ring=>ring.forEach(pt=>{
    const[px,py]=lccFn(pt);
    if(px<pMinX)pMinX=px;if(px>pMaxX)pMaxX=px;
    if(py<pMinY)pMinY=py;if(py>pMaxY)pMaxY=py;
  }));

  const xSpan=pMaxX-pMinX||.0001;
  const ySpan=pMaxY-pMinY||.0001;
  const draw=SIZE-2*PAD,scale=Math.min(draw/xSpan,draw/ySpan);
  const pw=xSpan*scale,ph=ySpan*scale;
  const ox=PAD+(draw-pw)/2,oy=PAD+(draw-ph)/2;
  shapeRatio=pw/ph;

  function proj([lo,la]){
    const[px,py]=lccFn([lo,la]);
    return[ox+(px-pMinX)*scale,oy+(py-pMinY)*scale];
  }
  _proj=proj;

  /* Simplify a projected ring and return the point array (or null if degenerate) */
  function simplifyRing(ring){
    let pts=ring.map(proj).filter(([x,y])=>isFinite(x)&&isFinite(y));
    if(!pts.length) return null;
    let rMinX=Infinity,rMaxX=-Infinity,rMinY=Infinity,rMaxY=-Infinity;
    pts.forEach(([x,y])=>{if(x<rMinX)rMinX=x;if(x>rMaxX)rMaxX=x;if(y<rMinY)rMinY=y;if(y>rMaxY)rMaxY=y;});
    const diag=Math.hypot(rMaxX-rMinX,rMaxY-rMinY);
    if(diag<1) return null;
    if(pts.length>4) pts=rdp(pts,Math.min(smoothEdges?eps*4:eps, diag*(smoothEdges?0.10:0.08)));
    if(pts.length<3) return null;
    /* Chaikin smoothing: extra passes when smooth mode on */
    const totalSmooth=Math.max(smoothIter, smoothEdges?3:0);
    if(totalSmooth>0) pts=chaikin(pts,totalSmooth);
    return pts;
  }

  function ringToD(pts){
    return'M'+pts.map(p=>p[0].toFixed(1)+','+p[1].toFixed(1)).join('L')+'Z';
  }

  const simOuters=outers.map(simplifyRing).filter(Boolean);
  const simInners=inners.map(simplifyRing).filter(Boolean);

  /* Island filter: remove isolated rings smaller than 5% of the main shape's
     bounding-box diagonal. Keeps major islands (Sicily, Sardinia, Crete) while
     eliminating tiny specks that are impossible to laser cut. */
  function ringDiag(ring){
    let mnX=Infinity,mxX=-Infinity,mnY=Infinity,mxY=-Infinity;
    ring.forEach(([x,y])=>{if(x<mnX)mnX=x;if(x>mxX)mxX=x;if(y<mnY)mnY=y;if(y>mxY)mxY=y;});
    return Math.hypot(mxX-mnX,mxY-mnY);
  }
  let finalOuters=simOuters, finalInners=simInners;
  if(islandFilter&&simOuters.length>1){
    const diags=simOuters.map(ringDiag);
    const maxDiag=Math.max(...diags);
    const minDiag=maxDiag*0.05;
    finalOuters=simOuters.filter((_,i)=>diags[i]>=minDiag);
    finalInners=simInners.filter(r=>ringDiag(r)>=minDiag);
  }

  _projRings={outers:finalOuters,inners:finalInners}; /* store for union export */

  const d=[...finalOuters,...finalInners].map(ringToD).join(' ');
  if(!d){showEmpty();setStatus('No boundary found — try a country, state, or city',true);return;}

  shapePath.setAttribute('d',d);
  previewSvg.setAttribute('viewBox',`0 0 ${SIZE} ${SIZE}`);
  placeLabel.textContent=label;
  applyVisuals();hideLoading();
  hasShape=true;btnDl.disabled=false;updateSizeNote();
  _hoopCx=null;_hoopCy=null; /* reset hoop to default top-centre on new shape */
  updateHoop();
}


document.getElementById('expH').addEventListener('input',updateSizeNote);

function applyVisuals(){
  shapePath.setAttribute('fill','#bc9468');
  shapePath.setAttribute('stroke','none');
  shapePath.setAttribute('stroke-width','0');
  previewSvg.style.padding='20px';
  updateHoop();
}

function heartColour(m){
  return m==='layered'?'#e03030':m==='engrave'?'#603913':'white';
}
function setHeartMode(m){
  heartMode=m;
  document.getElementById('tLayered').classList.toggle('on',m==='layered');
  document.getElementById('tEngrave').classList.toggle('on',m==='engrave');
  document.getElementById('tCutout').classList.toggle('on',m==='cutout');
  if(heartGroup.getAttribute('display')!=='none'){
    heartPath.setAttribute('fill',heartColour(m));
  }
}
document.getElementById('tLayered').addEventListener('click',()=>setHeartMode('layered'));
document.getElementById('tEngrave').addEventListener('click',()=>setHeartMode('engrave'));
document.getElementById('tCutout').addEventListener('click',()=>setHeartMode('cutout'));

function setIslandFilter(on){
  islandFilter=on;
  document.getElementById('tIslandOff').classList.toggle('on',!on);
  document.getElementById('tIslandOn').classList.toggle('on',on);
  if(cachedData) renderShape(cachedData);
}
document.getElementById('tIslandOff').addEventListener('click',()=>setIslandFilter(false));
document.getElementById('tIslandOn').addEventListener('click',()=>setIslandFilter(true));

function setSmoothEdges(on){
  smoothEdges=on;
  document.getElementById('tSmoothOff').classList.toggle('on',!on);
  document.getElementById('tSmoothOn').classList.toggle('on',on);
  if(cachedData) renderShape(cachedData);
}
document.getElementById('tSmoothOff').addEventListener('click',()=>setSmoothEdges(false));
document.getElementById('tSmoothOn').addEventListener('click',()=>setSmoothEdges(true));

/* ── Text engrave ── */
const engravingTextEl=document.getElementById('engravingTextEl');
const engravingInput=document.getElementById('engravingInput');



function setUnit(u){
  const expH=document.getElementById('expH');
  const val=parseFloat(expH.value)||0;
  if(val&&u!==currentUnit){
    expH.value=u==='mm'?(val*25.4).toFixed(1):(val/25.4).toFixed(2);
  }
  currentUnit=u;
  document.getElementById('uMm').classList.toggle('on',u==='mm');
  document.getElementById('uIn').classList.toggle('on',u==='in');
  updateSizeNote();
}
document.getElementById('uMm').addEventListener('click',()=>setUnit('mm'));
document.getElementById('uIn').addEventListener('click',()=>setUnit('in'));

function updateSizeNote(){
  const sizenote=document.getElementById('sizenote');
  if(!hasShape){sizenote.textContent='—';return;}
  const h=parseFloat(document.getElementById('expH').value)||4;
  sizenote.textContent=`${(h*shapeRatio).toFixed(2)} × ${h} ${currentUnit}`;
}

function showEmpty(){
  previewSvg.style.opacity='0';emptyOverlay.style.display='flex';
  loadOverlay.style.display='none';placeLabel.textContent='';
  hasShape=false;btnDl.disabled=true;sizenote.textContent='—';
  inSpin.style.display='none';cachedData=null;_proj=null;
  _projRings={outers:[],inners:[]};
  _hoopCx=null;_hoopCy=null;
  clearHeart();
  hoopGroup.setAttribute('display','none');
}
function showLoading(msg){
  loadMsg.textContent=msg;loadOverlay.style.display='flex';
  emptyOverlay.style.display='none';previewSvg.style.opacity='.15';
  inSpin.style.display='block';
}
function hideLoading(){
  loadOverlay.style.display='none';previewSvg.style.opacity='1';
  inSpin.style.display='none';
}
function setStatus(msg,isErr){
  statusMsg.textContent=msg;
  statusMsg.className='status-line'+(isErr?' err':' ok');
}

/* ── Address / heart marker ── */
const addrInput =document.getElementById('addrInput');
const addrClear =document.getElementById('addrClear');
const addrSpin  =document.getElementById('addrSpin');
const addrStatus=document.getElementById('addrStatus');
const heartGroup=document.getElementById('heartGroup');
const heartPath =document.getElementById('heartPath');
let addrDebounce=null;

addrInput.addEventListener('input',()=>{
  addrClear.style.display=addrInput.value?'block':'none';
  clearTimeout(addrDebounce);
  const q=addrInput.value.trim();
  clearHeart(); /* always clear immediately — new input invalidates old position */
  if(!q){addrStatus.textContent='';addrStatus.className='status-line';return;}
  addrDebounce=setTimeout(()=>geocodeAddress(q),700);
});
addrInput.addEventListener('keydown',e=>{
  if(e.key==='Enter'){clearTimeout(addrDebounce);const q=addrInput.value.trim();if(q)geocodeAddress(q);}
});
addrClear.addEventListener('click',()=>{addrInput.value='';addrClear.style.display='none';clearHeart();addrStatus.textContent='';addrStatus.className='status-line';});
function clearHeart(){
  heartGroup.setAttribute('display','none');
  _lastHeartSx=null;_lastHeartSy=null;
  _heartOffsetX=0;_heartOffsetY=0;
  const slX=document.getElementById('slHeartX');
  const slY=document.getElementById('slHeartY');
  if(slX){slX.value=0;document.getElementById('heartXVal').textContent='0';}
  if(slY){slY.value=0;document.getElementById('heartYVal').textContent='0';}
}

async function geocodeAddress(query){
  addrSpin.style.display='block';
  addrStatus.textContent='';addrStatus.className='status-line';
  try{
    const url=`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1`;
    const data=await getJson(url,8000);
    if(!data||!data.length){
      addrStatus.textContent='Address not found';addrStatus.className='status-line err';
      addrSpin.style.display='none';return;
    }
    const lo=parseFloat(data[0].lon),la=parseFloat(data[0].lat);
    if(!_proj){
      addrStatus.textContent='Load a place first';addrStatus.className='status-line err';
      addrSpin.style.display='none';return;
    }
    const[sx,sy]=_proj([lo,la]);
    placeHeart(sx,sy);
    _lastHeartSx=sx;_lastHeartSy=sy;
    addrStatus.textContent=data[0].display_name.split(',').slice(0,3).join(', ');
    addrStatus.className='status-line ok';
  }catch(err){
    addrStatus.textContent='Error: '+err.message;addrStatus.className='status-line err';
  }
  addrSpin.style.display='none';
}

const HEART_PATH_D="M398.833,454.607c-3.01-4.073-6.025-7.897-9.357-11.497c-7.2-7.777-15.502-14.479-23.663-21.32 c-6.068-5.085-12.182-10.127-17.279-16.126c-7.072-8.324-10.721-17.75-10.526-28.43c0.266-14.547,12.506-27.786,27.857-29.68 c12.945-1.597,23.634,5.085,31.732,14.807c0.378,0.453,0.643,1.011,1.305,1.356c0.977-1.115,1.917-2.254,2.927-3.334 c4.959-5.305,11.152-11.412,18.532-12.642c19.295-3.216,34.175,8.283,38.101,22.236c2.91,10.346,0.658,20.04-5.02,29.126 c-4.209,6.737-10.081,12.163-16.133,17.417c-7.429,6.448-15.201,12.546-22.314,19.316c-5.592,5.323-10.625,11.062-15.026,17.286 C399.651,453.571,399.299,454,398.833,454.607z";
const HEART_CX=399,HEART_CY=401,HEART_W=122,HEART_H=108;

function heartSizeFromSlider(){
  const v=parseInt(document.getElementById('slHeartSize').value);
  const halfH=Math.round(5+Math.pow(v/100,1.6)*55);
  const label=v<25?'S':v<50?'M':v<75?'L':'XL';
  document.getElementById('heartSizeVal').textContent=label;
  return halfH;
}

function placeHeart(sx,sy){
  const halfH=heartSizeFromSlider();
  const scale=(halfH*2)/HEART_H;
  const ax=sx+_heartOffsetX, ay=sy+_heartOffsetY;
  const tx=ax-HEART_CX*scale;
  const ty=ay-HEART_CY*scale;
  heartPath.setAttribute('d',HEART_PATH_D);
  heartPath.setAttribute('transform',`translate(${tx.toFixed(2)},${ty.toFixed(2)}) scale(${scale.toFixed(4)})`);
  heartPath.setAttribute('fill',heartColour(heartMode));
  heartGroup.setAttribute('display','');
}

let _lastHeartSx=null,_lastHeartSy=null;
let _heartOffsetX=0,_heartOffsetY=0;

document.getElementById('slHeartSize').addEventListener('input',()=>{
  if(_lastHeartSx!==null) placeHeart(_lastHeartSx,_lastHeartSy);
});

document.getElementById('slHeartX').addEventListener('input',function(){
  _heartOffsetX=parseInt(this.value);
  document.getElementById('heartXVal').textContent=(_heartOffsetX>0?'+':'')+_heartOffsetX;
  if(_lastHeartSx!==null) placeHeart(_lastHeartSx,_lastHeartSy);
});

document.getElementById('slHeartY').addEventListener('input',function(){
  _heartOffsetY=parseInt(this.value);
  document.getElementById('heartYVal').textContent=(_heartOffsetY>0?'+':'')+_heartOffsetY;
  if(_lastHeartSx!==null) placeHeart(_lastHeartSx,_lastHeartSy);
});

/* ── Hoop ── */
const hoopGroup =document.getElementById('hoopGroup');
const hoopOuter =document.getElementById('hoopOuter');
const hoopHole  =document.getElementById('hoopHole');
const HOOP_R    =24;   /* outer radius (preview + export, same viewBox) */
const HOOP_HL   =12;   /* hole radius */
const HOOP_OVL  =10;   /* default initial overlap into map top */

/* make hoop circles interactive */
hoopOuter.style.cursor='grab';
hoopHole.style.cursor='grab';
hoopOuter.setAttribute('pointer-events','all');
hoopHole.setAttribute('pointer-events','all');

document.getElementById('tNoHoop').addEventListener('click',()=>setHoop(false));
document.getElementById('tAddHoop').addEventListener('click',()=>setHoop(true));

function setHoop(on){
  hoopEnabled=on;
  if(!on){_hoopCx=null;_hoopCy=null;}
  document.getElementById('tNoHoop').classList.toggle('on',!on);
  document.getElementById('tAddHoop').classList.toggle('on',on);
  document.getElementById('hoopTip').style.display=on?'block':'none';
  document.getElementById('hoopDragHint').style.display=on?'block':'none';
  updateHoop();
}

/* Convert a mouse/touch event to SVG viewBox coordinates */
function toSvgPt(e){
  const pt=previewSvg.createSVGPoint();
  const src=e.touches?e.touches[0]:e;
  pt.x=src.clientX;pt.y=src.clientY;
  return pt.matrixTransform(previewSvg.getScreenCTM().inverse());
}

/* Attach drag listeners to both hoop circles */
function hoopDragStart(e){
  if(!hoopEnabled||!hasShape) return;
  e.preventDefault();
  _dragging=true;
  const p=toSvgPt(e);
  _dox=p.x-_hoopCx; _doy=p.y-_hoopCy;
  hoopOuter.style.cursor=hoopHole.style.cursor='grabbing';
}
hoopOuter.addEventListener('mousedown',hoopDragStart);
hoopHole.addEventListener('mousedown',hoopDragStart);
hoopOuter.addEventListener('touchstart',hoopDragStart,{passive:false});
hoopHole.addEventListener('touchstart',hoopDragStart,{passive:false});

document.addEventListener('mousemove',e=>{
  if(!_dragging) return;
  const p=toSvgPt(e);
  _hoopCx=p.x-_dox; _hoopCy=p.y-_doy;
  positionHoopEl();
});
document.addEventListener('touchmove',e=>{
  if(!_dragging) return;
  e.preventDefault();
  const p=toSvgPt(e);
  _hoopCx=p.x-_dox; _hoopCy=p.y-_doy;
  positionHoopEl();
},{passive:false});
document.addEventListener('mouseup',()=>{
  if(_dragging){_dragging=false;hoopOuter.style.cursor=hoopHole.style.cursor='grab';}
});
document.addEventListener('touchend',()=>{_dragging=false;});

function positionHoopEl(){
  hoopOuter.setAttribute('cx',_hoopCx.toFixed(2));
  hoopOuter.setAttribute('cy',_hoopCy.toFixed(2));
  hoopHole.setAttribute('cx',_hoopCx.toFixed(2));
  hoopHole.setAttribute('cy',_hoopCy.toFixed(2));
  /* Keep viewBox expanded during drag */
  if(hoopEnabled){
    const pad=8;
    const minX=Math.min(0,_hoopCx-HOOP_R-pad);
    const minY=Math.min(0,_hoopCy-HOOP_R-pad);
    const maxX=Math.max(500,_hoopCx+HOOP_R+pad);
    const maxY=Math.max(500,_hoopCy+HOOP_R+pad);
    previewSvg.setAttribute('viewBox',`${minX.toFixed(1)} ${minY.toFixed(1)} ${(maxX-minX).toFixed(1)} ${(maxY-minY).toFixed(1)}`);
  }
}

function updateHoop(){
  if(!hasShape||!hoopEnabled){
    hoopGroup.setAttribute('display','none');
    previewSvg.setAttribute('viewBox','0 0 500 500');
    return;
  }
  if(_hoopCx===null){
    const bbox=shapePath.getBBox();
    _hoopCx=bbox.x+bbox.width/2;
    _hoopCy=bbox.y-HOOP_R+HOOP_OVL;
  }
  positionHoopEl();
  hoopOuter.setAttribute('r',HOOP_R);
  hoopHole.setAttribute('r',HOOP_HL);
  hoopOuter.setAttribute('fill','#bc9468');
  hoopOuter.setAttribute('stroke','none');
  hoopOuter.setAttribute('stroke-width','0');
  hoopHole.setAttribute('fill','#ffffff');
  hoopHole.setAttribute('stroke','none');
  hoopHole.setAttribute('stroke-width','0');
  hoopGroup.setAttribute('display','');

  /* Expand the preview viewBox so the hoop ring is never clipped */
  const pad=8;
  const minX=Math.min(0,_hoopCx-HOOP_R-pad);
  const minY=Math.min(0,_hoopCy-HOOP_R-pad);
  const maxX=Math.max(500,_hoopCx+HOOP_R+pad);
  const maxY=Math.max(500,_hoopCy+HOOP_R+pad);
  previewSvg.setAttribute('viewBox',`${minX.toFixed(1)} ${minY.toFixed(1)} ${(maxX-minX).toFixed(1)} ${(maxY-minY).toFixed(1)}`);
}

/* ── Boolean union: arbitrary polygon + circle ─────────────────────────────
   Produces a single merged SVG path so the export is a true weld with no
   overlapping cut lines. Falls back to additive subpaths if the geometry
   is ambiguous (fully inside/outside, or >2 crossings on the main ring).
──────────────────────────────────────────────────────────────────────────── */

function segCircleIntersect(A,B,cx,cy,r){
  const dx=B[0]-A[0],dy=B[1]-A[1];
  const fx=A[0]-cx,fy=A[1]-cy;
  const a=dx*dx+dy*dy;
  if(a<1e-12) return[];
  const b=2*(fx*dx+fy*dy);
  const c=fx*fx+fy*fy-r*r;
  const disc=b*b-4*a*c;
  if(disc<0) return[];
  const sq=Math.sqrt(Math.max(0,disc));
  const out=[];
  for(const s of[(-b-sq)/(2*a),(-b+sq)/(2*a)]){
    if(s>=-1e-9&&s<=1+1e-9){
      const t=Math.max(0,Math.min(1,s));
      out.push({x:A[0]+t*dx,y:A[1]+t*dy,t});
    }
  }
  if(out.length===2&&Math.abs(out[0].t-out[1].t)<1e-9) return[out[0]];
  return out;
}

function ptInRing(px,py,ring){
  let inside=false;
  for(let i=0,j=ring.length-1;i<ring.length;j=i++){
    const xi=ring[i][0],yi=ring[i][1],xj=ring[j][0],yj=ring[j][1];
    if((yi>py)!==(yj>py)&&px<(xj-xi)*(py-yi)/(yj-yi)+xi) inside=!inside;
  }
  return inside;
}

/* circle path helper: two 180° arcs, CW (sweep=1) or CCW (sweep=0) */
function svgCirclePath(cx,cy,r,cw=true){
  const s=cw?1:0;
  return `M${(cx+r).toFixed(3)},${cy.toFixed(3)} A${r},${r},0,1,${s},${(cx-r).toFixed(3)},${cy.toFixed(3)} A${r},${r},0,1,${s},${(cx+r).toFixed(3)},${cy.toFixed(3)}Z`;
}

function buildUnionD(ring,cx,cy,outerR,holeR){
  const n=ring.length;

  /* 1. Find crossings; determine entering/exiting via dot product.
        Winding-direction-independent — correct for any hoop position. */
  const crossings=[];
  for(let i=0;i<n;i++){
    const A=ring[i],B=ring[(i+1)%n];
    for(const h of segCircleIntersect(A,B,cx,cy,outerR)){
      const edx=B[0]-A[0],edy=B[1]-A[1];
      /* edge pointing toward centre → polygon entering circle */
      const entering=(cx-h.x)*edx+(cy-h.y)*edy>0;
      crossings.push({x:h.x,y:h.y,t:h.t,segI:i,entering,
        angle:Math.atan2(h.y-cy,h.x-cx)});
    }
  }

  /* 2. Exactly two crossings required */
  if(crossings.length!==2) return null;
  crossings.sort((a,b)=>a.segI!==b.segI?a.segI-b.segI:a.t-b.t);
  const[C1,C2]=crossings;

  /* 3. C1.entering=true → polygon enters circle at C1 → C1→C2 is INSIDE circle */
  const c1c2Inside=C1.entering;

  let pS,pE,aS,aE;
  if(c1c2Inside){pS=C2;pE=C1;aS=C1;aE=C2;}
  else          {pS=C1;pE=C2;aS=C2;aE=C1;}

  /* 4. Count-based polygon walk — immune to same-edge degenerate case.
        directCount = vertices in C1→C2 path (by index, the shorter arc by index).
        wrapCount   = the rest (the other way around the ring). */
  const directCount=C2.segI-C1.segI;
  const wrapCount=n-directCount;
  const walkCount=c1c2Inside?wrapCount:directCount;

  const parts=[`M${pS.x.toFixed(3)},${pS.y.toFixed(3)}`];
  let vi=(pS.segI+1)%n;
  for(let k=0;k<walkCount;k++){
    parts.push(`L${ring[vi][0].toFixed(1)},${ring[vi][1].toFixed(1)}`);
    vi=(vi+1)%n;
  }
  parts.push(`L${pE.x.toFixed(3)},${pE.y.toFixed(3)}`);

  /* 5. Determine arc direction: test midpoints of both arc choices against polygon */
  const a1=aS.angle,a2=aE.angle;
  const spanCW =((a2-a1)+2*Math.PI)%(2*Math.PI); /* sweep=1 in SVG */
  const spanCCW=((a1-a2)+2*Math.PI)%(2*Math.PI); /* sweep=0 in SVG */
  const tCW =[cx+outerR*0.97*Math.cos(a1+spanCW/2), cy+outerR*0.97*Math.sin(a1+spanCW/2)];
  const tCCW=[cx+outerR*0.97*Math.cos(a1-spanCCW/2),cy+outerR*0.97*Math.sin(a1-spanCCW/2)];
  const cwIn =ptInRing(tCW[0], tCW[1], ring);
  const ccwIn=ptInRing(tCCW[0],tCCW[1],ring);

  let sweep,arcSpan;
  if(!cwIn&&ccwIn)     {sweep=1;arcSpan=spanCW;}
  else if(cwIn&&!ccwIn){sweep=0;arcSpan=spanCCW;}
  else return null; /* ambiguous — fall back to additive subpaths */

  const large=arcSpan>Math.PI?1:0;
  parts.push(`A${outerR},${outerR},0,${large},${sweep},${aE.x.toFixed(3)},${aE.y.toFixed(3)}Z`);

  /* 6. Carry through inner rings and island rings that lie outside the hoop */
  const mainD=parts.join('');
  let extraD='';
  const cen=r=>{const s=r.reduce((a,p)=>[a[0]+p[0],a[1]+p[1]],[0,0]);return[s[0]/r.length,s[1]/r.length];};
  for(const inner of _projRings.inners){
    const[icx,icy]=cen(inner);
    if(Math.hypot(icx-cx,icy-cy)>outerR)
      extraD+=' M'+inner.map(p=>p[0].toFixed(1)+','+p[1].toFixed(1)).join('L')+'Z';
  }
  for(const outer of _projRings.outers){
    if(outer===ring) continue;
    const[icx,icy]=cen(outer);
    if(Math.hypot(icx-cx,icy-cy)>outerR)
      extraD+=' M'+outer.map(p=>p[0].toFixed(1)+','+p[1].toFixed(1)).join('L')+'Z';
  }
  return mainD+extraD+' '+svgCirclePath(cx,cy,holeR,false);
}

/* ── Path transform helper: bake translate+scale into a bezier path d string ── */
function transformPathD(d,tx,ty,s){
  const tokens=d.match(/[MmCcZz]|[-+]?\d*\.?\d+(?:[eE][-+]?\d+)?/g)||[];
  const out=[];let i=0;
  const rd=()=>parseFloat(tokens[i++]);
  const ta=n=>(n*s+tx).toFixed(3);  /* absolute: scale then translate */
  const tr=n=>(n*s).toFixed(3);     /* relative: scale only */
  while(i<tokens.length){
    const cmd=tokens[i++];
    if(cmd==='M'){out.push(`M${ta(rd())},${ta(rd())}`);}
    else if(cmd==='C'){
      const ns=[];while(i<tokens.length&&!/[MCZz]/i.test(tokens[i]))ns.push(rd());
      for(let j=0;j<ns.length;j+=6)
        out.push(`C${ta(ns[j])},${ta(ns[j+1])},${ta(ns[j+2])},${ta(ns[j+3])},${ta(ns[j+4])},${ta(ns[j+5])}`);
    }
    else if(cmd==='c'){
      const ns=[];while(i<tokens.length&&!/[MCZz]/i.test(tokens[i]))ns.push(rd());
      for(let j=0;j<ns.length;j+=6)
        out.push(`c${tr(ns[j])},${tr(ns[j+1])},${tr(ns[j+2])},${tr(ns[j+3])},${tr(ns[j+4])},${tr(ns[j+5])}`);
    }
    else if(cmd==='Z'||cmd==='z'){out.push('Z');}
  }
  return out.join('');
}

/* ── Font definitions ── */
const FONTS=[
  {name:'Abril Fatface',     css:"'Abril Fatface',serif",       woff:'https://cdn.jsdelivr.net/npm/@fontsource/abril-fatface@4/files/abril-fatface-latin-400-normal.woff'},
  {name:'Alex Brush',        css:"'Alex Brush',cursive",        woff:'https://cdn.jsdelivr.net/npm/@fontsource/alex-brush@4/files/alex-brush-latin-400-normal.woff'},
  {name:'Anton',             css:"'Anton',sans-serif",          woff:'https://cdn.jsdelivr.net/npm/@fontsource/anton@4/files/anton-latin-400-normal.woff'},
  {name:'Bebas Neue',        css:"'Bebas Neue',sans-serif",     woff:'https://cdn.jsdelivr.net/npm/@fontsource/bebas-neue@4/files/bebas-neue-latin-400-normal.woff'},
  {name:'Caveat',            css:"'Caveat',cursive",            woff:'https://cdn.jsdelivr.net/npm/@fontsource/caveat@4/files/caveat-latin-400-normal.woff'},
  {name:'Cinzel',            css:"'Cinzel',serif",              woff:'https://cdn.jsdelivr.net/npm/@fontsource/cinzel@4/files/cinzel-latin-400-normal.woff'},
  {name:'Cormorant Garamond',css:"'Cormorant Garamond',serif",  woff:'https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@4/files/cormorant-garamond-latin-400-normal.woff'},
  {name:'Dancing Script',    css:"'Dancing Script',cursive",    woff:'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script@4/files/dancing-script-latin-400-normal.woff'},
  {name:'Great Vibes',       css:"'Great Vibes',cursive",       woff:'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes@4/files/great-vibes-latin-400-normal.woff'},
  {name:'Josefin Sans',      css:"'Josefin Sans',sans-serif",   woff:'https://cdn.jsdelivr.net/npm/@fontsource/josefin-sans@4/files/josefin-sans-latin-400-normal.woff'},
  {name:'Pacifico',          css:"'Pacifico',cursive",          woff:'https://cdn.jsdelivr.net/npm/@fontsource/pacifico@4/files/pacifico-latin-400-normal.woff'},
  {name:'Pinyon Script',     css:"'Pinyon Script',cursive",     woff:'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script@4/files/pinyon-script-latin-400-normal.woff'},
  {name:'Playfair Display',  css:"'Playfair Display',serif",    woff:'https://cdn.jsdelivr.net/npm/@fontsource/playfair-display@4/files/playfair-display-latin-400-normal.woff'},
  {name:'Raleway',           css:"'Raleway',sans-serif",        woff:'https://cdn.jsdelivr.net/npm/@fontsource/raleway@4/files/raleway-latin-400-normal.woff'},
  {name:'Satisfy',           css:"'Satisfy',cursive",           woff:'https://cdn.jsdelivr.net/npm/@fontsource/satisfy@4/files/satisfy-latin-400-normal.woff'},
];
let currentFontIdx=0;

/* Build custom font picker */
(function(){
  const picker =document.getElementById('fontPicker');
  const selected=document.getElementById('fontSelected');
  const selText =document.getElementById('fontSelectedText');
  const dropdown=document.getElementById('fontDropdown');

  FONTS.forEach((f,i)=>{
    const el=document.createElement('div');
    el.className='font-opt'+(i===0?' active':'');
    el.style.fontFamily=f.css;
    el.textContent=f.name;
    el.addEventListener('click',e=>{
      e.stopPropagation();
      currentFontIdx=i;
      selText.textContent=f.name;
      selText.style.fontFamily=f.css;
      dropdown.querySelectorAll('.font-opt').forEach((o,j)=>o.classList.toggle('active',j===i));
      dropdown.classList.remove('open');
      updateEngravingText();
    });
    dropdown.appendChild(el);
  });

  selected.addEventListener('click',e=>{
    e.stopPropagation();
    dropdown.classList.toggle('open');
  });
  document.addEventListener('click',()=>dropdown.classList.remove('open'));
})();

/* ── opentype.js text-to-paths (WOFF via @fontsource on jsDelivr) ── */
const _fontCache={};
async function ensureOpentype(){
  if(window.opentype) return;
  await new Promise((res,rej)=>{
    const s=document.createElement('script');
    s.src='https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js';
    s.onload=res;s.onerror=rej;
    document.head.appendChild(s);
  });
}
async function loadOpentypeFont(fontDef){
  const key=fontDef.name;
  if(_fontCache[key]) return _fontCache[key];
  try{
    await ensureOpentype();
    /* Use WOFF (v1) from @fontsource — opentype.js handles WOFF natively, no Brotli needed */
    const font=await new Promise((res,rej)=>{
      opentype.load(fontDef.woff,(err,f)=>err?rej(err):res(f));
    });
    _fontCache[key]=font;
    return font;
  }catch(e){console.error('Font load error for "'+key+'":', e);return null;}
}

function updateEngravingText(){
  const txt=engravingInput.value.trim();
  if(!txt||!hasShape){engravingTextEl.setAttribute('display','none');return;}
  const sv=parseInt(document.getElementById('slTextSize').value);
  const fontSize=10+Math.pow(sv/100,0.7)*50;
  const sLabel=sv<25?'S':sv<50?'M':sv<75?'L':'XL';
  document.getElementById('textSizeVal').textContent=sLabel;
  const x=30+(parseInt(document.getElementById('slTextX').value)/100)*440;
  const y=30+(parseInt(document.getElementById('slTextY').value)/100)*440;
  const fDef=FONTS[currentFontIdx];
  engravingTextEl.setAttribute('font-family',fDef.css);
  engravingTextEl.setAttribute('font-weight','400');
  engravingTextEl.setAttribute('x',x.toFixed(1));
  engravingTextEl.setAttribute('y',y.toFixed(1));
  engravingTextEl.setAttribute('font-size',fontSize.toFixed(1));
  engravingTextEl.setAttribute('display','');
  engravingTextEl.textContent=txt;
}

engravingInput.addEventListener('input',updateEngravingText);
document.getElementById('slTextSize').addEventListener('input',updateEngravingText);
document.getElementById('slTextX').addEventListener('input',updateEngravingText);
document.getElementById('slTextY').addEventListener('input',updateEngravingText);

/* ── Paper.js boolean union for connected text paths ── */
let _paperReady=false;
async function ensurePaperJS(){
  if(window.paper&&_paperReady) return;
  if(!window.paper){
    await new Promise((res,rej)=>{
      const s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/paper@0.12.17/dist/paper-core.min.js';
      s.onload=res;s.onerror=rej;
      document.head.appendChild(s);
    });
  }
  if(!_paperReady){
    const c=document.createElement('canvas');
    c.width=8000;c.height=4000;
    paper.setup(c);
    _paperReady=true;
  }
}

async function unitePaths(glyphPaths){
  /* glyphPaths: array of opentype.Path objects, one per glyph.
     Keeping each glyph as a CompoundPath preserves the outer stroke + inner
     counter (hole) relationship. Uniting BETWEEN glyphs then merges overlapping
     letter strokes while keeping letter openings intact. */
  await ensurePaperJS();
  try{
    paper.project.clear();
    const valid=glyphPaths.filter(g=>g.commands&&g.commands.length>0);
    if(!valid.length) return '';
    const items=valid.map(g=>{
      const d=g.toPathData(3);
      if(!d||!d.trim()) return null;
      try{ return new paper.CompoundPath({pathData:d}); }catch(_){ return null; }
    }).filter(Boolean);
    if(!items.length) return valid.map(g=>g.toPathData(3)).join('');
    if(items.length===1){
      const out=items[0].pathData; items[0].remove(); paper.project.clear(); return out||'';
    }
    let result=items[0];
    for(let i=1;i<items.length;i++){
      const u=result.unite(items[i]);
      result.remove();items[i].remove();result=u;
    }
    const out=result.pathData;
    result.remove();paper.project.clear();
    return out||valid.map(g=>g.toPathData(3)).join('');
  }catch(e){
    console.warn('Path unite failed:',e);
    return glyphPaths.map(g=>g.toPathData(3)).join('');
  }
}

btnDl.addEventListener('click',async()=>{
  const h=parseFloat(document.getElementById('expH').value)||4;
  let w=(h*shapeRatio).toFixed(3),label=placeLabel.textContent;

  /* ── Build map path (with optional welded hoop) ── */
  let mapD=shapePath.getAttribute('d');
  if(hoopEnabled&&_hoopCx!==null){
    let mainRing=_projRings.outers[0]||null;
    if(_projRings.outers.length>1){
      let best=0;
      _projRings.outers.forEach((r,i)=>{if(r.length>_projRings.outers[best].length)best=i;});
      mainRing=_projRings.outers[best];
    }
    const unionD=mainRing?buildUnionD(mainRing,_hoopCx,_hoopCy,HOOP_R,HOOP_HL):null;
    mapD=unionD||(mapD+` ${svgCirclePath(_hoopCx,_hoopCy,HOOP_R,true)} ${svgCirclePath(_hoopCx,_hoopCy,HOOP_HL,false)}`);
  }

  /* ── Compute export viewBox from bounding boxes of all elements ── */
  const mapBbox=shapePath.getBBox();
  const pad=14;
  let vMinX=mapBbox.x-pad, vMinY=mapBbox.y-pad;
  let vMaxX=mapBbox.x+mapBbox.width+pad, vMaxY=mapBbox.y+mapBbox.height+pad;

  /* Expand for hoop (circle at _hoopCx/Cy with radius HOOP_R) */
  if(hoopEnabled&&_hoopCx!==null){
    vMinX=Math.min(vMinX,_hoopCx-HOOP_R-pad);
    vMinY=Math.min(vMinY,_hoopCy-HOOP_R-pad);
    vMaxX=Math.max(vMaxX,_hoopCx+HOOP_R+pad);
    vMaxY=Math.max(vMaxY,_hoopCy+HOOP_R+pad);
  }

  /* ── Heart handling ── */
  const heartVisible=heartGroup.getAttribute('display')!=='none';
  let heartEl='';

  if(heartVisible){
    const halfH=heartSizeFromSlider();
    const hs=(halfH*2)/HEART_H;
    /* Heart center in SVG space (matches preview exactly) */
    const ax=_lastHeartSx+_heartOffsetX, ay=_lastHeartSy+_heartOffsetY;

    /* For engraved + layered: use SVG transform attribute directly — no baking needed,
       guaranteed to match the preview rendering.
       For cut-out: must bake into the map d string (evenodd subpath).
       Use the exact transform values already on the preview heartPath element. */
    const renderedTransform=heartPath.getAttribute('transform')||'';

    if(heartMode==='cutout'){
      /* Separate cut-line path at exact preview position — same approach as engraved.
         Laser software cuts both the map outline and the heart outline,
         producing a heart-shaped hole. fill="none" = cut line only. */
      heartEl=`\n  <path fill="none" stroke="black" stroke-width="1" stroke-linejoin="round" transform="${renderedTransform}" d="${HEART_PATH_D}"/>`;
      /* Expand viewBox — heart may sit near map edge */
      vMinX=Math.min(vMinX,ax-HEART_W*hs/2-pad);
      vMinY=Math.min(vMinY,ay-HEART_H*hs/2-pad);
      vMaxX=Math.max(vMaxX,ax+HEART_W*hs/2+pad);
      vMaxY=Math.max(vMaxY,ay+HEART_H*hs/2+pad);
    } else if(heartMode==='engrave'){
      /* Exact same transform as preview → exact same position */
      heartEl=`\n  <path fill="#1a56ff" stroke="none" transform="${renderedTransform}" d="${HEART_PATH_D}"/>`;
      /* Expand viewBox using heart centre ± half-dimensions */
      vMinX=Math.min(vMinX,ax-HEART_W*hs/2-pad);
      vMinY=Math.min(vMinY,ay-HEART_H*hs/2-pad);
      vMaxX=Math.max(vMaxX,ax+HEART_W*hs/2+pad);
      vMaxY=Math.max(vMaxY,ay+HEART_H*hs/2+pad);
    } else {
      /* Layered — place heart to the right of map, vertically centred.
         Use SVG transform attribute (no baking) for simplicity and correctness. */
      const gap=18;
      const hcx=mapBbox.x+mapBbox.width+gap+HEART_W*hs/2;
      const hcy=mapBbox.y+mapBbox.height/2;
      const ltx=hcx-HEART_CX*hs, lty=hcy-HEART_CY*hs;
      const layeredTransform=`translate(${ltx.toFixed(3)},${lty.toFixed(3)}) scale(${hs.toFixed(5)})`;
      heartEl=`\n  <path fill="none" stroke="black" stroke-width="1" stroke-linejoin="round" transform="${layeredTransform}" d="${HEART_PATH_D}"/>`;
      /* Expand viewBox for layered heart using centre ± half-dimensions */
      vMaxX=Math.max(vMaxX,hcx+HEART_W*hs/2+pad);
      vMinY=Math.min(vMinY,hcy-HEART_H*hs/2-pad);
      vMaxY=Math.max(vMaxY,hcy+HEART_H*hs/2+pad);
    }
  }

  /* ── Engraving text → converted to paths via opentype.js ── */
  let textExportEl='';
  if(engravingTextEl.getAttribute('display')!=='none'){
    const tx=parseFloat(engravingTextEl.getAttribute('x'));
    const ty=parseFloat(engravingTextEl.getAttribute('y'));
    const fs=parseFloat(engravingTextEl.getAttribute('font-size'));
    const tc=engravingTextEl.textContent;
    const fontFamily=FONTS[currentFontIdx].css;
    /* Expand viewBox for text (approximate width) */
    const approxW=tc.length*fs*0.62;
    vMinX=Math.min(vMinX,tx-approxW/2-pad);
    vMaxX=Math.max(vMaxX,tx+approxW/2+pad);
    vMinY=Math.min(vMinY,ty-fs-pad);
    vMaxY=Math.max(vMaxY,ty+fs*0.3+pad);
    try{
      /* Load font and convert to paths */
      const font=await loadOpentypeFont(FONTS[currentFontIdx]);
      if(font){
        /* Centre the text: compute advance width and start from tx-width/2 */
        const advW=font.getAdvanceWidth(tc,fs);
        const startX=tx-advW/2;
        /* getPaths: one Path per glyph — outer+inner stay together, counters preserved */
        const glyphPaths=font.getPaths(tc,startX,ty,fs);
        const unitedD=await unitePaths(glyphPaths);
        textExportEl=`\n  <path fill="#1a56ff" fill-rule="nonzero" d="${unitedD}"/>`;
      } else {
        /* Fallback: SVG text element */
        const safeText=tc.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        textExportEl=`\n  <text x="${tx}" y="${ty}" font-size="${fs.toFixed(1)}" font-family="${fontFamily}" font-weight="400" text-anchor="middle" fill="#1a56ff">${safeText}</text>`;
      }
    }catch(e){
      const safeText=tc.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      textExportEl=`\n  <text x="${tx}" y="${ty}" font-size="${fs.toFixed(1)}" font-family="${fontFamily}" font-weight="400" text-anchor="middle" fill="#1a56ff">${safeText}</text>`;
    }
  }

  /* ── Legend: expand viewBox downward and add colour key ── */
  const vbH0=vMaxY-vMinY;                        /* original content height */
  const legFs=Math.max(6, vbH0*0.028);           /* font-size: 2.8% of content height */
  const legPad=legFs*0.6;                        /* gap between content and legend */
  const legY=vMaxY+legPad+legFs;                 /* baseline of legend text */
  const legCx=(vMinX+vMaxX)/2;                   /* centred on the artwork */
  const legViewMaxY=legY+legFs*0.4;              /* bottom edge inc. descenders */

  /* Expand viewBox and recalculate physical width */
  const vbW=vMaxX-vMinX, vbH2=legViewMaxY-vMinY;
  const viewBox=`${vMinX.toFixed(2)} ${vMinY.toFixed(2)} ${vbW.toFixed(2)} ${vbH2.toFixed(2)}`;
  w=(h*vbW/vbH2).toFixed(3);

  const dot=`<tspan fill="#999"> · </tspan>`;
  const legendEl=`\n  <text x="${legCx.toFixed(2)}" y="${legY.toFixed(2)}" `+
    `font-family="sans-serif" font-size="${legFs.toFixed(2)}" text-anchor="middle" letter-spacing="0.03em">`+
    `<tspan fill="#111111" font-weight="600">Black</tspan>`+
    `<tspan fill="#555555"> = Cut</tspan>`+
    dot+
    `<tspan fill="#1a56ff" font-weight="600">Blue</tspan>`+
    `<tspan fill="#555555"> = Engrave</tspan>`+
    `</text>`;

  /* ── Assemble SVG ──
     Map = black outline cut line (no fill).
     Engraved heart = blue fill.
     Layered heart = black outline (separate cut piece). ── */
  const safeLabel=label.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  /* Guard: if mapD is empty or starts with invalid chars, abort */
  if(!mapD||!mapD.trim().startsWith('M')){alert('Map path is empty — please load a shape first.');return;}

  const svg=`<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="${w}${currentUnit}" height="${h}${currentUnit}" viewBox="${viewBox}">\n  <title>${safeLabel}</title>\n  <path fill-rule="evenodd" fill="none" stroke="black" stroke-width="1" stroke-linejoin="round" d="${mapD}"/>${heartEl}${textExportEl}${legendEl}\n</svg>`;
  const a=document.createElement('a');
  a.href=URL.createObjectURL(new Blob([svg],{type:'image/svg+xml'}));
  a.download=`${label.replace(/[^a-z0-9]/gi,'-').toLowerCase()}-silhouette.svg`;
  a.click();URL.revokeObjectURL(a.href);
});

document.getElementById('btnRst').addEventListener('click',()=>{
  placeName.value='';clearBtn.style.display='none';
  addrInput.value='';addrClear.style.display='none';clearHeart();
  addrStatus.textContent='';addrStatus.className='status-line';
  setHeartMode('layered');setUnit('in');document.getElementById('expH').value=4;
  setIslandFilter(false);setSmoothEdges(false);
  engravingInput.value='';engravingTextEl.setAttribute('display','none');
  setHoop(false);
  lastFetched='';showEmpty();setStatus('');
});

showEmpty();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',_mapGenInit);
} else {
  _mapGenInit();
}
})();


// ── Analytics tracking ───────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  // Track place name entry (debounced 800ms, fires once per pause)
  const placeNameInput = document.getElementById('placeName');

  let nameTimeout;

  placeNameInput.addEventListener('input', function () {
    clearTimeout(nameTimeout);

    nameTimeout = setTimeout(() => {
      if (placeNameInput.value.trim() !== '') {
        gtag('event', 'mapsilhouette_place_name_entered', {
          event_category: 'generator',
          generator_type: 'mapsilhouette',
          event_label: 'place_name_input_used',
          place_name: placeNameInput.value.trim()
        });
      }
    }, 800);
  });

  // Track SVG downloads
  const downloadBtn = document.getElementById('btnDl');

  downloadBtn.addEventListener('click', function () {
    gtag('event', 'mapsilhouette_download_svg', {
      event_category: 'generator',
      generator_type: 'mapsilhouette',
      place_name: placeNameInput.value.trim()
    });
  });

});